import React from "react";
import { useDangerConfirm } from "../../../shared/context/DangerConfirmContext.jsx";
import { Card } from "../../../shared/components/Card.jsx";
import { Badge } from "../../../shared/components/Badge.jsx";

export function ItemCard({ item, onEdit, onDelete, onSelect }) {
  const { confirmDanger } = useDangerConfirm();
  const isLowStock = item.itemType !== "service" && Number(item.stock) <= Number(item.reorderLevel || 10);
  const unitLabel = item.unit || "pcs";

  return (
    <Card className="item-card">
      <div className="item-row" onClick={() => onSelect && onSelect(item)}>
        <div className="item-main">
          <div className="item-title">
            <span style={{ marginRight: "6px" }}>
              {item.itemType === "service" ? "⚙️" : "📦"}
            </span>
            {item.itemName || item.name}
          </div>
          <div className="item-sku">
            HSN/SAC: {item.gstCode || "N/A"}
          </div>
          <div className="item-meta">
            <Badge variant="info">{item.itemType === "service" ? "Service" : "Goods"}</Badge>
            <Badge variant="info">{item.gstPercent || 0}% GST</Badge>
            {item.itemType !== "service" && (
              isLowStock ? (
                <Badge variant="danger">Low Stock: {item.stock} {unitLabel}</Badge>
              ) : (
                <Badge variant="success">Stock: {item.stock} {unitLabel}</Badge>
              )
            )}
          </div>
        </div>

        <div className="item-stats">
          <div className="item-price">
            ₹{Number(item.basicPrice || item.sellingPrice || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
          </div>
          <div style={{ fontSize: "0.75rem", color: "var(--text-dim)" }}>
            per {unitLabel}
          </div>
          {Number(item.costPrice || 0) > 0 && (
            <div style={{ fontSize: "0.72rem", color: "var(--text-dim)", marginTop: "2px" }}>
              Cost: ₹{Number(item.costPrice).toFixed(2)}
            </div>
          )}
        </div>
      </div>

      <div style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "0.5rem",
        marginTop: "0.75rem",
        paddingTop: "0.75rem",
        borderTop: "1px solid var(--border-subtle)"
      }}>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(item);
          }}
        >
          ✏️ Edit
        </button>
        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={async (e) => {
            e.stopPropagation();
            if (await confirmDanger({ title: "Delete item?", message: `Delete "${item.itemName || item.name}"?` })) {
              onDelete(item.id);
            }
          }}
        >
          🗑️ Delete
        </button>
      </div>
    </Card>
  );
}

export default ItemCard;
